var _dec, _class, _Item;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { omitProps } from '@instructure/ui-react-utils';
import { View } from '@instructure/ui-view';
import { withStyle } from '@instructure/emotion';
import generateStyle from './styles';
import { propTypes, allowedProps } from './props';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
---
parent: Flex
id: Flex.Item
---
**/
let Item = (_dec = withStyle(generateStyle, null), _dec(_class = (_Item = class Item extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  render() {
    const props = omitProps(this.props, Item.allowedProps);
    const _this$props3 = this.props,
      as = _this$props3.as,
      children = _this$props3.children,
      withVisualDebug = _this$props3.withVisualDebug,
      textAlign = _this$props3.textAlign,
      size = _this$props3.size,
      direction = _this$props3.direction,
      margin = _this$props3.margin,
      padding = _this$props3.padding,
      overflowX = _this$props3.overflowX,
      overflowY = _this$props3.overflowY,
      styles = _this$props3.styles;
    const dirColumn = direction === 'column';
    const dirRow = direction === 'row';
    return _jsx(View, {
      ...props,
      css: styles === null || styles === void 0 ? void 0 : styles.flexItem,
      elementRef: this.handleRef,
      as: as,
      minHeight: dirColumn ? size : void 0,
      minWidth: dirRow ? size : void 0,
      textAlign: textAlign,
      margin: margin,
      padding: padding,
      overflowX: overflowX,
      overflowY: overflowY || (dirColumn ? 'auto' : 'visible'),
      withVisualDebug: withVisualDebug,
      children: children
    });
  }
}, _Item.displayName = "Item", _Item.componentId = 'Flex.Item', _Item.propTypes = propTypes, _Item.allowedProps = allowedProps, _Item.defaultProps = {
  as: 'span',
  shouldGrow: false,
  shouldShrink: false
}, _Item)) || _class);
export default Item;
export { Item };